import requestService from '@/services/request'
import { urlSearchParams } from '@/util/urlSearchParams'

/**
 * Retrieves a paginated list of limit orders
 * @param {string} question_id - The ID of the question
 * @returns {Promise<Object>} The paginated limit orders response
 */
async function getAll(question_id, options) {
  const params = new urlSearchParams(options)
  const response = await requestService.get(`/questions/${question_id}/order_book/?${params.toString()}`)

  if (response.ok) {
    return response.json()
  }

  throw new Error(`server error: ${response.status}`)
}

/**
 * Retrieves a user's limit orders
 * @param {Object} options - Filter options
 * @param {string} options.currency_mode - (required) Filter by currency mode (play_money or real_money)
 * @param {string} options.question - (required) Filter by market (question ID)
 * @param {string} options.outcome - (optional) Filter by specific outcome within the market
 * @returns {Promise<Object>} The user's limit orders response
 */
async function getUserOrders(options) {
  const params = new urlSearchParams(options)
  const response = await requestService.get(`/orders/user_book/?${params.toString()}`)

  if (response.ok) {
    return response.json()
  }

  throw new Error(`server error: ${response.status}`)
}

/**
 * Place a new limit order
 * @param {Object} orderData - The limit order data
 * @returns {Promise<Object>} The created limit order response
 */
async function create(orderData) {
  const response = await requestService.post('/orders/', {
    body: JSON.stringify(orderData),
  })

  if (response.ok) {
    return response.json()
  }

  throw new Error(`server error: ${response.status}`)
}

/**
 * Cancel a limit order
 * @param {string} orderId - The ID of the limit order to cancel
 * @returns {Promise<Object>} The response data
 */
async function cancel(orderId) {
  const response = await requestService.delete(`/limit_order/${orderId}/`)

  if (response.ok) {
    return response.json()
  }

  throw new Error(`server error: ${response.status}`)
}

export default {
  getAll,
  getUserOrders,
  create,
  cancel,
}

export const LimitOrderAPIService = {
  getAll,
  getUserOrders,
  create,
  cancel,
}
